import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { isInPage } from '@beef/utils';

import { useIsDesktopDimension } from 'hooks';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

// todo: прижимание футера к низу страницы (надо понять, как будет добавлен сам хедер и футер)
export const Layout = ({ sideBar, children }) => {
  const [topPosition, setTopPosition] = useState(null);
  const isDesktop = useIsDesktopDimension();

  useEffect(() => {
    if (isDesktop) {
      const $siteHeader = document.querySelector('[data-component="site-header"]');
      if (isInPage($siteHeader)) {
        setTopPosition($siteHeader.offsetHeight);
      }
    } else {
      setTopPosition(null);
    }
  }, [setTopPosition, isDesktop]);

  return (
    <div className={cn('wrap')}>
      <main className={`${cn('main')} global-content-fixer`}>
        <aside
          className={cn('sidebar')}
          style={{
            top: topPosition,
          }}
        >
          {sideBar}
        </aside>
        <div className={cn('main-content')}>{children}</div>
      </main>
    </div>
  );
};

Layout.propTypes = {
  sideBar: PropTypes.node,
  children: PropTypes.node,
};
